/**
 * TanStack Query hooks for `carrier-isp-targeting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	carrierIspTargetingQueryKeys,
	type CreateCarrierIspTargetingBody,
	type ListCarrierIspTargetingResponse,
	type CarrierIspTargetingRow,
} from "./api";

export function useCarrierIspTargetingList(): UseQueryResult<ListCarrierIspTargetingResponse, Error> {
	return useQuery({
		queryKey: carrierIspTargetingQueryKeys.list(),
		queryFn: list,
	});
}

export function useCarrierIspTargetingCreate(): UseMutationResult<CarrierIspTargetingRow, Error, CreateCarrierIspTargetingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: carrierIspTargetingQueryKeys.all });
		},
	});
}

export function useCarrierIspTargetingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: carrierIspTargetingQueryKeys.all });
		},
	});
}
